import Vue from "vue"; // 实例化Vue
import i18n from '../tools/i18n'
var bus = new Vue({i18n});

Vue.prototype.$elementMessage = function (msg, t) {
    this.$message({
        message: msg,
        type: t,
        duration: 1000
    });
};

export default bus;



// WEBPACK FOOTER //
// ./src/components/bus.js